<template>
  <div>
    <div class="popupBg"></div>
    <div class="noticePopupWrap" :class="{height: !noticeList.noticeImageURL}">
      <div>
        <!-- [수정] 250822:: 황태용, 코드 수정:S -->
        <!-- <p class="noticePopupRegDt">{{noticeList.fromDate}}</p> -->
        <!-- [수정] 250822:: 황태용, 코드 수정:E -->
        <p class="noticePopupTit">{{noticeList.noticeTitle}}</p>
      </div>
      <div class="noticeContainer">
        <div class="noticePopupScroll" :class="{height: noticeList.noticeImageURL}">
          <img :src="noticeList.noticeImageURL" class="noticePopupImg" v-if="noticeList.noticeImageURL">
          <p class="noticePopupTxt">{{noticeList.popContent}}</p>
        </div>
        <div class="noticePopupBtns">
          <div class="noticeDetailBtn" @click="MoveDetail(noticeList.noticeSeq)" v-if="noticeList.popYn == 'Y' && noticeList.contYn == 'Y'">자세히보기</div>
          <div class="d-flex flex-space-between flex-x-center" style="margin: 14px 8px 0">
            <div>
              <label class="d-flex flex-x-center">
                <input type="checkbox" v-model="localPopupTomorrowFlag">
                <span style="margin-right:4px;"></span>
                <span class="txt">
                  <span>오늘 하루 보지 않기</span>
                </span>
              </label>
            </div>
            <div @click="handleClose" style="font-weight:bold; width:50px; text-align:right">닫기</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['noticeList', 'popupIndex', 'popupTomorrowFlag'],
  computed: {
    localPopupTomorrowFlag: {
      get () {
        return this.popupTomorrowFlag
      },
      set (value) {
        this.$emit('updatePopupFlag', this.popupIndex, value)
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('updatePopupFlag', this.popupIndex, this.popupTomorrowFlag)
      this.$emit('closePopup')
    },
    MoveDetail (seq) {
      this.$router.push({ name: 'AppNoticeDetail', params: { noticeSeq: seq } })
    }
  }
}
</script>

<style scoped>
input[type="checkbox"]+span {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  background: url('../../assets/img/btn_check_off_2.png') no-repeat;
  background-size: cover;
  flex-shrink: 0;
}
input[type="checkbox"]:checked+span {
  background: url('../../assets/img/Btn_check_on_2.png') no-repeat;
  background-size: cover;
}
</style>
